export default __webpack_public_path__ + "static/media/lock.54cf3290.svg";